import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import API from "../../utils/api";

// Async Thunk for Category API Call
export const fetchAppCategories = createAsyncThunk(
  "appliance_category/fetchAppCategories",
  async (_, { rejectWithValue }) => {
    try {
      const response = await API.get("/appliance-categories");
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response.data.message);
    }
  }
);

// export const fetchCategoryProducts = createAsyncThunk(
//   "appliance_category/fetchCategoryProducts",
//   async ({ categoryId, page = 1, perPage = 10 }, { rejectWithValue }) => {
//     try {      
//       const response = await API.get(`/categoryproduct/${categoryId}?page=${page}&perPage=${perPage}`);
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data?.message || "Something went wrong");
//     }
//   }
// );

const appCategorySlice = createSlice({
  name: "appliance_category",
  initialState: {
    app_categories: [],
    app_cat_products: [],
    app_cat_loading: false,
    app_cat_error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAppCategories.pending, (state) => {
        state.app_cat_loading = true;
      })
      .addCase(fetchAppCategories.fulfilled, (state, action) => {
        state.app_cat_loading = false;
        state.app_categories = action.payload;
      })
      .addCase(fetchAppCategories.rejected, (state, action) => {
        state.app_cat_loading = false;
        state.app_cat_error = action.payload;
      })
    //   .addCase(fetchCategoryProducts.pending, (state) => {
    //     state.app_cat_loading = true;
    //   })
    //   .addCase(fetchCategoryProducts.fulfilled, (state, action) => {
    //     state.app_cat_loading = false;
    //     state.cat_products = action.payload;
    //   })
    //   .addCase(fetchCategoryProducts.rejected, (state, action) => {
    //     state.app_cat_loading = false;
    //     state.cat_error = action.payload;
    //   });
  },
});

export default appCategorySlice.reducer;
